import { createFileRoute } from "@tanstack/react-router";
import { MemoDetailPage } from "@/features/memo/MemoDetailPage";
import { loadPublic } from "@/lib/guards";

export const Route = createFileRoute("/memos/$uid")({
  beforeLoad: loadPublic,
  component: MemoDetailPage,
});
